@if (loading()) {
  <div class="loading">
    <div id="loader-wrapper">
      <div class="loader">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="subline"></div>
        <div class="subline"></div>
        <div class="subline"></div>
        <div class="subline"></div>
        <div class="subline"></div>
        <div class="loader-circle-1">
          <div class="loader-circle-2"></div>
        </div>
        <div class="needle"></div>
        <div class="loading">{{ 'common.loading' | translate }}</div>
      </div>
    </div>
  </div>
}
